import React from "react";
import { useTranslation } from "react-i18next";
import TopBar from "../../components/TopBar";
import Footer from "../../components/Footer";

const ComponentName: React.FC = () => {
  const { t } = useTranslation();
  const [showIndex, setShowIndex] = React.useState<number>(0);
  return (
    <div className="">
      <TopBar />
      <div className="relative"
        style={{
          backgroundImage: `url(${require("../../assets/image/icon15.png")})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }} >
        <div className="text-[#181512] text-[45px] py-[118px] font-[700] w-[955px] mx-auto 
        h5:text-center h5:text-[30px] h5:w-full h5:py-[68px] relative z-10">常見問題</div>

        <div className="absolute top-0 left-0 right-0 bottom-0"
          style={{
            background: 'linear-gradient(to right, #fbfbfbc2, transparent)',
            bottom: '0',
            content: "",
            left: '0',
            pointerEvents: 'auto',
            position: 'absolute',
            right: '0',
            top: '0',
            zIndex: 1
          }}></div>
      </div>

      <div className="w-[770px] mx-auto py-[72px] h5:w-full h5:px-[16px]">
        <div>
          <div className="flex items-center cursor-pointer pb-20 mb-20"
            onClick={() => setShowIndex(showIndex === 1 ? 0 : 1)}
            style={{
              borderBottom: "1px solid #ccc",
            }}>
            <div className="flex-1 text-[#181512] text-[24px] font-bold h5:text-[20px]">在詩肯柚木我可以找到什麼？</div>
            <img src={require("../../assets/image/icon1.png")}
              className={`w-[16px] ${showIndex === 1 ? 'rotate-[90deg]' : ''}`}
              alt="" />
          </div>
          <div className={`${showIndex === 1 ? 'block' : 'hidden'}`}>
            <div className="text-[#595959] text-[18px] mb-[20px]">
              在詩肯柚木您可以找到優質柚木所製成的家具，如客廳的沙發/電視櫃、餐廳的餐桌椅、臥室的床架/收納櫃/衣櫃、自有品牌及德國原裝的床墊寢具，還有點綴佈置的地毯、抱枕、玩偶等家飾品。
            </div>
            <div className="text-[#595959] text-[18px]">
              詩肯柚木不僅是家具更是您的左鄰右舍，我們專業且親切的門市同仁經過完善的教育訓練，了解客戶的需求後提供相對應的建議及配置計畫，陪伴您一同成長的生活夥伴。
            </div>
            <br />
          </div>
        </div>
        <div>
          <div className="flex items-center cursor-pointer pb-20 mb-20"
            onClick={() => setShowIndex(showIndex === 2 ? 0 : 2)}
            style={{
              borderBottom: "1px solid #ccc",
            }}>
            <div className="flex-1 text-[#181512] text-[24px] font-bold h5:text-[20px]">選擇「柚木」家具的好處？</div>
            <img src={require("../../assets/image/icon1.png")}
              className={`w-[16px] ${showIndex === 2 ? 'rotate-[90deg]' : ''}`}
              alt="" />
          </div>
          <div className={`${showIndex === 2 ? 'block' : 'hidden'}`}>
            <div className="text-[#595959] text-[18px] mb-[20px]">
              柚木以其耐用性和堅固性而聞名，不僅耐候性強，而且比其他任何木材都耐磨。它還具有防潮，防腐和防蟲的作用。詩肯嚴選純天然，且對於製程的甲醛釋出量嚴格把關，以確保家具產品使用安全無虞並符合規定。如想瞭解更多，點擊這裡您會知道選擇詩肯柚木的原因。          </div>
            <div className="text-[#595959] text-[18px]">
              ※柚木特性：柚木為內含自然柚木油的天然木材。柚木油隨時會在本產品的表面分泌生成，此為正常現象。 <br />
              在經過一段時間後，木頭的顏色會逐漸變成銀灰色；這是柚木自然老化的特徵。
            </div><br />
          </div>
        </div>
        <div>
          <div className="flex items-center cursor-pointer pb-20 mb-20"
            onClick={() => setShowIndex(showIndex === 3 ? 0 : 3)}
            style={{
              borderBottom: "1px solid #ccc",
            }}>
            <div className="flex-1 text-[#181512] text-[24px] font-bold h5:text-[20px]">如何維護保養及正確使用柚木家具？</div>
            <img src={require("../../assets/image/icon1.png")}
              className={`w-[16px] ${showIndex === 3 ? 'rotate-[90deg]' : ''}`}
              alt="" />
          </div>
          <div className={`${showIndex === 3 ? 'block' : 'hidden'}`}>
            <div className="text-[#595959] text-[18px] mb-[20px]">
              詩肯嚴選100%天然並經合法認證的好柚木，家具製程更經過多層細膩的專業加工處理。為使家具處於最佳狀態，在使用與維護時建議：
            </div>
            <div className="text-[#595959] text-[18px]">
              1.定期地清理本產品並以乾淨的布擦乾。 <br />
              2.任何污漬或污物請立刻以沾濕的乾淨軟布加以擦拭乾淨，清理產品時應順著木紋擦拭。 <br />
              3.請勿塗抺任何會損壞產品的磨蝕性化學品，請勿使用壓力清洗裝置，否則會使木頭的質地受損。 <br />
              4.使用餐墊 / 杯墊以避免直接與家具接觸。 <br />
              5.木材為天然產物。這意謂著它的顏色及紋理會有所變化，在使用一段時間後會出現細微的龜裂，這些細紋並不會損及產品的品質及功能。 <br />
              6.柚木出油屬商品正常現象，清潔保養方法請洽門市服務人員。 <br />
              7.櫃類商品建議鎖牆增加商品穩固性，使用時勿同時打開2個以上抽屜，並請盡量將重物置於較低層的抽屜中。 <br />
              8.若商品有可調式之固定零件(例如:頭枕五金、卡榫…等)，請確保其在穩固狀態下再行使用，防止意外發生。 <br />
              9.定期檢查產品的狀況，即時維護或更換損壞零件。 <br />
              10.於安全、乾燥、平坦處的環境中使用產品。 <br />
              11.對於商品有使用、安全上的疑慮，請立即洽詢門市服務人員。 <br />
              12.如居家環境較為潮濕時，請保持室內通風並加以清潔，以避免商品發霉。 <br />
            </div><br />
          </div>
        </div>
        <div>
          <div className="flex items-center cursor-pointer pb-20 mb-20"
            onClick={() => setShowIndex(showIndex === 4 ? 0 : 4)}
            style={{
              borderBottom: "1px solid #ccc",
            }}>
            <div className="flex-1 text-[#181512] text-[24px] font-bold h5:text-[20px]">訂單注意事項有哪些?</div>
            <img src={require("../../assets/image/icon1.png")}
              className={`w-[16px] ${showIndex === 4 ? 'rotate-[90deg]' : ''}`}
              alt="" />
          </div>
          <div className={`${showIndex === 4 ? 'block' : 'hidden'}`}>
            <div className="text-[#595959] text-[18px] mb-[20px]">
              一、除以下另有規定外，買方於簽訂本訂單時，須至少支付訂單總貨款一成數額作為定金，並於出貨前應將剩餘貨款全數付清，否則賣方得不予出貨。
            </div>
            <div className="text-[#595959] text-[18px] mb-[20px]">
              二、賣方恕不接受支票付款方式。
            </div>
            <div className="text-[#595959] text-[18px] mb-[20px]">
              三、當買方要求延期送貨時，運送時間將由賣方另行排定。
            </div>
            <div className="text-[#595959] text-[18px] mb-[20px]">
              四、賣方對因天災、事變、不可抗力等因素而造成之延誤不負遲延責任，買方對此不得為任何請求或主張。
            </div>
            <div className="text-[#595959] text-[18px] mb-[20px]">
              五、買方若因不可歸責於賣方之事由而取消訂單時，賣方得沒收定金之全額。
            </div>
            <div className="text-[#595959] text-[18px] mb-[20px]">
              六、本訂單自簽訂日起六個月內有效。買方若未於有效期內完成取貨，賣方有權取消本訂單，並沒收定金之全額。
            </div>
            <div className="text-[#595959] text-[18px] mb-[20px]">
              七、如買方欲變更雙方於簽訂契約時約定之交貨日，買方應於取貨日前一週通知門市人員，以利安排出貨。
            </div>
            <div className="text-[#595959] text-[18px] mb-[20px]">
              八、由於商品種類眾多，如遇商品缺貨、停產或其他相類因素而無法出貨，賣方將提供類似商品作為可出貨商品之參考；如買方對於賣方提供之類似商品不願買受時，得取消訂單，但買方不得向賣方請求賠償。
            </div>
            <div className="text-[#595959] text-[18px] mb-[20px]">
              九、客製化服務產品(依賣方規定認定)，經買方簽訂本訂單後，須支付訂單總貨款全額作為定金。客製化商品售出後，不得退貨或換貨，保固範圍一律以維修方式處理。
            </div>
            <div className="text-[#595959] text-[18px] mb-[20px]">
              十、購買商品時，如有折扣優惠、贈品、加購商品等，辦理退貨時須ㄧ併退還，如贈品或加購商品為個人衛生用品時，ㄧ經拆封須以原價購買。
            </div>
            <div className="text-[#595959] text-[18px]">
              十ㄧ、優惠活動之參與資格與辦法需以賣家公告之內容為主，若買方未符合活動資格，賣方有權取消本訂單。
            </div><br />
          </div>
        </div>
        <div>
          <div className="flex items-center cursor-pointer pb-20 mb-20"
            onClick={() => setShowIndex(showIndex === 5 ? 0 : 5)}
            style={{
              borderBottom: "1px solid #ccc",
            }}>
            <div className="flex-1 text-[#181512] text-[24px] font-bold h5:text-[20px]">收貨時應注意那些事項?</div>
            <img src={require("../../assets/image/icon1.png")}
              className={`w-[16px] ${showIndex === 5 ? 'rotate-[90deg]' : ''}`}
              alt="" />
          </div>
          <div className={`${showIndex === 5 ? 'block' : 'hidden'}`}>
            <div className="text-[#595959] text-[18px]">
              1.買方於商品運達時，應立即檢查，買方若怠於檢查者，視為所受領之商品無瑕疵。 <br /><br />
              2.買方所選購的商品為展示品、出清品，經簽收確認後(包含他人代收簽名確認)，恕不提供退、換貨服務，請於購買前確認商品折舊情形。 <br /><br />
              3.床墊、寢具、織品屬個人清潔用品，經買賣雙方點收確認後，恕不接受退貨或換貨。 <br /><br />
              4.門市現場取貨之商品，經買賣雙方點收確認後，恕不接受退貨或換貨。 <br /><br />
              5.賣方將商品送達指定地點，如他人代收簽名，視同買方同意本訂單所列各事項規定。 <br /><br />
              6.賣方將商品送達指定地點，買方未將剩餘貨款給付完全時，賣方有權將商品收回，且得向買方請求因此所生之運送、保管或其他必要費用，買方絕無異議。 <br /><br />
              7.商品點收完成後，非賣方商品結構瑕疵之換貨，賣方將酌收來回運費；若為布套、皮沙發、板材家具等特殊商品，需額外收取相關耗材費用，並將另行報價。 <br /><br />
              8.商品經買賣雙方點收確認後概不退貨，僅限因商品結構瑕疵，請於點收日起算七日內通知賣方人員，並經賣方確認後依適當時程安排更換商品，超過期限者恕無法更換。 <br /><br />
              9.實木製品保有天然木質，每件家具的紋理皆無法相同，門市陳列商品、板材樣品僅供參考，恕不接受因天然紋路(木節)、商品色澤辦理退貨或換貨。
            </div><br />
          </div>
        </div>
        <div>
          <div className="flex items-center cursor-pointer pb-20 mb-20"
            onClick={() => setShowIndex(showIndex === 6 ? 0 : 6)}
            style={{
              borderBottom: "1px solid #ccc",
            }}>
            <div className="flex-1 text-[#181512] text-[24px] font-bold h5:text-[20px]">是否可了解商品保固內容?</div>
            <img src={require("../../assets/image/icon1.png")}
              className={`w-[16px] ${showIndex === 6 ? 'rotate-[90deg]' : ''}`}
              alt="" />
          </div>
          <div className={`${showIndex === 6 ? 'block' : 'hidden'}`}>
            <div className="text-[#595959] text-[18px] mb-[20px]">
              一、柚木系列(木製傢俱)、居家系列(茶几、餐桌、餐椅、床架、櫃類等)：
            </div>
            <div className="text-[#595959] text-[18px] mb-[20px]">
              非人為因素之商品結構瑕疵(如：斷裂、裂開、鬆脫等)，自出貨日起三年內免收維修費；自出貨日起三年後買方須負擔維修費。
            </div>
            <div className="text-[#595959] text-[18px] mb-[20px]">
              二、床墊商品：
            </div>
            <div className="text-[#595959] text-[18px] mb-[20px]">
              正常使用下，出貨日起一年內非人為因素造成彈簧結構變形損壞，免收維修費；自出貨日起一年後買方須負擔維修費。其餘自然使用狀態下所造成之原料耗損更換(床布、內材、泡棉…等)，須另酌收材料及相關衍生之費用。
            </div>
            <div className="text-[#595959] text-[18px] mb-[20px]">
              三、上述各類商品於出貨日起一年內保固範圍之維修買家免付運費（惟若依賣方規定運送距離為遠程者，運費另計）；自出貨日起一年後買方須負擔運費。
            </div>
            <div className="text-[#595959] text-[18px] mb-[20px]">
              四、非商品保固範圍之維修服務，由專業技師評估維修項目，須收取材料、維修費及運費。
            </div>
            <div className="text-[#595959] text-[18px] mb-[20px]">
              五、上述各類商品之以下狀況不適用保固範圍:
            </div>
            <div className="text-[#595959] text-[18px] mb-[20px]">
              1.不當使用商品，如:自行拆除、不當拖拉、搬移或修補產品
            </div>
            <div className="text-[#595959] text-[18px] mb-[20px]">
              2.外力破壞，如切割或刮傷、撞擊、衣物上配件(鈕扣、鉚釘)等造成商品損壞。
            </div>
            <div className="text-[#595959] text-[18px] mb-[20px]">
              3.使用非賣方的清潔產品、化學塗料(如:漂白劑、去光水、指甲油、清潔劑、其他染劑等造成商品損壞。)
            </div>
            <div className="text-[#595959] text-[18px] mb-[20px]">
              4.家中環境因素，商品放置室外、溫差過大或潮濕環境，造成商品發霉或變形。
            </div>
            <div className="text-[#595959] text-[18px] mb-[20px]">
              5.商品長時間曝曬在高熱度及輻射之下造成商品損壞。
            </div>
            <div className="text-[#595959] text-[18px] mb-[20px]">
              6.商品上置放合成化學物品，如橡皮擦、橡膠類止滑墊、隔熱墊、塑膠球、漆面物件（如皮革包等）等造成損壞。
            </div>
            <div className="text-[#595959] text-[18px] mb-[20px]">
              7.天然災害因素造成商品損壞。
            </div>
            <div className="text-[#595959] text-[18px] mb-[20px]">
              8.因自然耗損及寵物因素，如沙發表面皮/布自然損耗、髒汙、皺摺；水性、油性筆塗鴉；寵物排泄物所產生之味道、汙漬；寵物抓、咬等情況。
            </div>
            <div className="text-[#595959] text-[18px] mb-[20px]">
              9.展示品、出清品、各項零配件(USB配件、遙控器…等)、床布、內材、泡棉、玻璃、沙發布套…等消耗品，恕不在保固範圍內，須酌收材料、維修費及運費。
            </div>
            <div className="text-[#595959] text-[18px] mb-[20px]">
              六、買方須出示銷貨單或提供購買相關資訊，經確認為賣方銷售之商品，方得享有保固服務，故請妥善保存銷貨單，以利享有後續服務。 <br /><br />
              七、台灣地區銷售之產品，售後服務及保固條款僅限於台灣本島服務。離島及境外地區，請於出船碼頭或指定裝櫃處確實驗收品項、數量、商品品質等。<br /><br />
              八、商品保固範圍限家庭使用，不包含商業用途。<br /><br />
              九、當原買方轉售或轉讓賣方商品時，即終止商品保固服務。<br /><br />
              地板商品保固範圍<br /><br />
              一、自施工完成日起，保固一年，保固範圍僅限於施工不當導致木地板翹起、損壞等。<br /><br />
              非整體施工僅就施作部分提供保固。<br /><br />
              二、買方應於施工完成當日現場驗收，如有損傷須於完工日起算三日內通知賣方人員，超過期限則無法分辨損傷責任歸屬，恕不在保固範圍內。<br /><br />
              三、以下情況不適用保固範圍，維修費須由買方負擔：<br /><br />
              1.天然災害(水災、地震)導致地板毀損。<br /><br />
              2.建物滲水、漏水導致地板變形、翹起、變黑、釘子生鏽發黑。<br /><br />
              3.人為因素導致地板毀損，如水電、冷氣、木工、油漆，搬家等造成刮傷、毀損等。<br /><br />
              4.地板款項未結清者。<br /><br />
              5.堅持不按照賣方之工法及順序施作，而造成的後續問題者。<br /><br />
              6.蛀蟲以外之與賣方產品本身無關之不明原因之蟲害。<br /><br />
              7.當原買方轉售或轉讓賣方商品時，即終止商品保固服務。<br /><br />
            </div><br />
          </div>
        </div>
        <div>
          <div className="flex items-center cursor-pointer pb-20 mb-20"
            onClick={() => setShowIndex(showIndex === 7 ? 0 : 7)}
            style={{
              borderBottom: "1px solid #ccc",
            }}>
            <div className="flex-1 text-[#181512] text-[24px] font-bold h5:text-[20px]">我想知道哪些門市可以看到所有的商品?</div>
            <img src={require("../../assets/image/icon1.png")}
              className={`w-[16px] ${showIndex === 7 ? 'rotate-[90deg]' : ''}`}
              alt="" />
          </div>
          <div className={`${showIndex === 7 ? 'block' : 'hidden'}`}>
            <div className="text-[#595959] text-[18px]">
              詩肯柚木門市陳列皆是完整系列，會根據坪數空間設計略為異動擺設陳列之商品（如：方型客廳空間沙發陳列3+2+1 / 長型客廳空間陳列3+1），不過因陳列可能隨時變動，建議您來店之前來電做最後確認。 <br /><br />
            </div><br />
          </div>
        </div>
        <div>
          <div className="flex items-center cursor-pointer pb-20 mb-20"
            onClick={() => setShowIndex(showIndex === 8 ? 0 : 8)}
            style={{
              borderBottom: "1px solid #ccc",
            }}>
            <div className="flex-1 text-[#181512] text-[24px] font-bold h5:text-[20px]">是否有提供訂製傢俱服務？</div>
            <img src={require("../../assets/image/icon1.png")}
              className={`w-[16px] ${showIndex === 8 ? 'rotate-[90deg]' : ''}`}
              alt="" />
          </div>
          <div className={`${showIndex === 8 ? 'block' : 'hidden'}`}>
            <div className="text-[#595959] text-[18px]">
              抱歉，我們為進口家具不提供客製家具服務。 <br /><br />
            </div><br />
          </div>
        </div>
        <div>
          <div className="flex items-center cursor-pointer pb-20 mb-20"
            onClick={() => setShowIndex(showIndex === 9 ? 0 : 9)}
            style={{
              borderBottom: "1px solid #ccc",
            }}>
            <div className="flex-1 text-[#181512] text-[24px] font-bold h5:text-[20px]">請問門市營業時間是什麼時候呢？</div>
            <img src={require("../../assets/image/icon1.png")}
              className={`w-[16px] ${showIndex === 9 ? 'rotate-[90deg]' : ''}`}
              alt="" />
          </div>
          <div className={`${showIndex === 9 ? 'block' : 'hidden'}`}>
            <div className="text-[#595959] text-[18px]">
              您可以參考我們的門市據點，透過門市搜尋的功能，可以更快速了解接近您所在地的門市服務時間。 <br /><br />
            </div><br />
          </div>
        </div>
        <div>
          <div className="flex items-center cursor-pointer pb-20 mb-20"
            onClick={() => setShowIndex(showIndex === 10 ? 0 : 10)}
            style={{
              borderBottom: "1px solid #ccc",
            }}>
            <div className="flex-1 text-[#181512] text-[24px] font-bold h5:text-[20px]">請問運費如何計算？</div>
            <img src={require("../../assets/image/icon1.png")}
              className={`w-[16px] ${showIndex === 10 ? 'rotate-[90deg]' : ''}`}
              alt="" />
          </div>
          <div className={`${showIndex === 10 ? 'block' : 'hidden'}`}>
            <div className="text-[#595959] text-[18px]">
              一、單次運送貨品總額達免運費金額門檻(依賣方規定)，得同一地址免費運送一次；未滿免運費門檻買方須負擔運費。若依賣方規定運送距離為遠程者，運費另計(詳請參閱賣方之「全台地區運送滿額免運費一覽表」公告)。 <br /><br />
              二、限定大型家具(依賣方規定)若無電梯而需人工搬運服務，買方須負擔樓層搬運費(詳請參閱賣方之「大型家具搬運樓層之收費標準」公告)。 <br /><br />
              三、因空間尺寸因素(例如：樓梯過窄、電梯過小、門口過小等)無法直接搬運至指定地點，而需另外處理，致衍生之其他費用(例如：吊車費等)，買方應自行負擔此類其他費用。 <br /><br />
              <div>
                <img src={require("../../assets/image/icon23.jpg")} alt="" className="w-[80%]" />
              </div><br />
            </div>
          </div>
        </div>
        <div>
          <div className="flex items-center cursor-pointer pb-20 mb-20"
            onClick={() => setShowIndex(showIndex === 11 ? 0 : 11)}
            style={{
              borderBottom: "1px solid #ccc",
            }}>
            <div className="flex-1 text-[#181512] text-[24px] font-bold h5:text-[20px]">在詩肯柚木我可以使用哪些付款方式？</div>
            <img src={require("../../assets/image/icon1.png")}
              className={`w-[16px] ${showIndex === 11 ? 'rotate-[90deg]' : ''}`}
              alt="" />
          </div>
          <div className={`${showIndex === 11 ? 'block' : 'hidden'}`}>
            <div className="text-[#595959] text-[18px]">
              我們提供多樣化的付款方式，匯款、現金及信用卡 (VISA、Master、JCB)均有接受。另外，使用指定銀行信用卡，提供3-30期不等的分期零利率服務及分期回饋金。 <br /><br />
              ※    百貨通路等特殊櫃位，配合指定通路付款方式為主。 <br /><br />
            </div><br />
          </div>
        </div>
        <div>
          <div className="flex items-center cursor-pointer pb-20 mb-20"
            onClick={() => setShowIndex(showIndex === 12 ? 0 : 12)}
            style={{
              borderBottom: "1px solid #ccc",
            }}>
            <div className="flex-1 text-[#181512] text-[24px] font-bold h5:text-[20px]">我購買的商品需要換貨，該怎麼做呢？</div>
            <img src={require("../../assets/image/icon1.png")}
              className={`w-[16px] ${showIndex === 12 ? 'rotate-[90deg]' : ''}`}
              alt="" />
          </div>
          <div className={`${showIndex === 12 ? 'block' : 'hidden'}`}>
            <div className="text-[#595959] text-[18px]">
              如果您對於購買的產品有商品瑕疵，您可在 7日內與原購買門市聯繫換貨，攜帶統一發票及訂單明細（刷卡另需信用卡與簽單）至門市辦理。<br /><br />
              您也可以與詩肯客服（0800-358088）連繫確認，或 點選這裡 查詢各分店連絡方式。<br /><br />
              ※ 若您是透過詩肯官網線上購買，可到官網首頁會員中心的申請退貨為您進行退/換貨流程。<br /><br />
            </div><br />
          </div>
        </div>
        <div>
          <div className="flex items-center cursor-pointer pb-20 mb-20"
            onClick={() => setShowIndex(showIndex === 13 ? 0 : 13)}
            style={{
              borderBottom: "1px solid #ccc",
            }}>
            <div className="flex-1 text-[#181512] text-[24px] font-bold h5:text-[20px]">詩肯柚木的退款流程？</div>
            <img src={require("../../assets/image/icon1.png")}
              className={`w-[16px] ${showIndex === 13 ? 'rotate-[90deg]' : ''}`}
              alt="" />
          </div>
          <div className={`${showIndex === 13 ? 'block' : 'hidden'}`}>
            <div className="text-[#595959] text-[18px]">
              在詩肯柚木實體門市購買不適用鑑賞期，若您在商品運送完成後 7日內，針對商品退/換貨需求，請聯繫詩肯門市/客服人員，我們將派員前往進行商品判定，確認後相關資料無誤後至門市進行退款申請。<br /><br />
              (由於退款尚需7-14個工作天，因此會佔用你的信用卡額度，實際的退款時間將視你的發卡銀行作業時程而定。)<br /><br />
              ※若您是在詩肯官網線上購買，請在商品運送完成後 7日內，針對商品退/換貨需求，聯繫您所指定的售服門市/客服人員，並且填寫退款申請書及到官網首頁會員中心的申請退貨為您進行退/換貨流程，以利後續線上退款作業進行。<br /><br />
            </div><br />
          </div>
        </div>
        <div>
          <div className="flex items-center cursor-pointer pb-20 mb-20"
            onClick={() => setShowIndex(showIndex === 14 ? 0 : 14)}
            style={{
              borderBottom: "1px solid #ccc",
            }}>
            <div className="flex-1 text-[#181512] text-[24px] font-bold h5:text-[20px]">是否有收舊家具服務?</div>
            <img src={require("../../assets/image/icon1.png")}
              className={`w-[16px] ${showIndex === 14 ? 'rotate-[90deg]' : ''}`}
              alt="" />
          </div>
          <div className={`${showIndex === 14 ? 'block' : 'hidden'}`}>
            <div className="text-[#595959] text-[18px]">
              我們無提供回收舊家具或通知環保局的服務。敬請見諒，謝謝<br /><br />
            </div><br />
          </div>
        </div>
        <div>
          <div className="flex items-center cursor-pointer pb-20 mb-20"
            onClick={() => setShowIndex(showIndex === 15 ? 0 : 15)}
            style={{
              borderBottom: "1px solid #ccc",
            }}>
            <div className="flex-1 text-[#181512] text-[24px] font-bold h5:text-[20px]">【線上購物】是否有七天鑑賞期?</div>
            <img src={require("../../assets/image/icon1.png")}
              className={`w-[16px] ${showIndex === 15 ? 'rotate-[90deg]' : ''}`}
              alt="" />
          </div>
          <div className={`${showIndex === 15 ? 'block' : 'hidden'}`}>
            <div className="text-[#595959] text-[18px]">
              七天鑑賞期為商品全新狀態與包裝完整之情況下才可受理退換貨，個人因素需退換貨的狀況下則會收取來回運費。<br /><br />
              瑕疵標準：在未經使用及無人為外力破壞之下商品或商品運送所造成的破損及配件短缺。<br /><br />
              以下情形，不屬於商品瑕疵問題：<br />
              1.『色差問題』不屬於商品質量問題，因新舊電腦及每台電腦的顯示設定不同，難免會有色差，對色差要求嚴格者購買前請思量。或是請您到實體門市看過實品後再進行購買，以避免雙方不必要的誤會。<br /><br />
              2.實木家具為天然實木材質製作，因每株樹木生長情形及切面不同，所以每個實木家具都會有著獨一無二的天然木紋與木結，實木家具呈現的木紋與木結非人為蝦疵，望您理解每棵樹木都有其紋理風情，且根據”橫切“以及”縱切“、受潮度、陽光曝曬範圍，故可能導致紋理不同。<br /><br />
              3.商品除了特別註明為展示品之外皆為全新品，凡屬造型、氣味、功能不符期待或不適用等…皆不屬於商品瑕疵，請下單前謹慎思考。<br /><br />
              ※注意：因網路購物的商品皆是到貨就直接檢查包裝，煩請您商品收到後於24小時內開箱檢查，如有運送造成破損、配件不齊、商品損壞等情況，麻煩請提供圖片證明到客服信箱 hello@scanteak.com.tw。<br /><br />
            </div><br />
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ComponentName;
